import React from 'react'
import type { ComponentProps, MacroComponentData } from '@enonic/react-components'

import HubspotFormPrototype from './prototype/HubspotForm'
import type { HubspotFormProps } from './prototype/HubspotForm/types'

export const HubspotFormMacro = ({ data }: ComponentProps<MacroComponentData>) => {
	// The macro schema has no Heading, so the prototype's optional `heading` stays unset.
	const { region, portalId, formId, containerId } = (data || {}) as HubspotFormProps

	// Inside a RichText field the surrounding block already provides the
	// container, so no `isPart` here.
	return <HubspotFormPrototype region={region} portalId={portalId} formId={formId} containerId={containerId} />
}
